<template>
  <div class="d-flex flex-column h-100vh">
    <Header></Header>
    <div
      class="d-flex jc-center ai-center h-100 p-relative min-height overflow-y-overlay"
    >
      <div class="d-flex profile-main">
        <div class="d-flex flex-column ai-center menu">
          <router-link
            class="mt-4"
            active-class="active"
            tag="a"
            :to="`/${this.$i18n.locale}/password`"
          >
            {{ $t("nav.resetPassword") }}
          </router-link>
        </div>
        <div class="d-flex flex-column flex-1 h-100">
          <div class="subheader">{{ $t("password.title") }}</div>
          <div class="profile content d-flex flex-column ai-center">
            <div class="d-flex w-100 jc-end">
              <v-btn
                class="btn btn-update"
                color="primary"
                @click="updatePassword"
                depressed
                :disabled="!valid"
              >
                {{ $t("profile.updatePassword") }}
              </v-btn>
            </div>
            <v-form class="d-flex flex-column profile-form" v-model="valid">
              <label>{{ $t("profile.newPassword") }}</label>
              <v-text-field
                v-model="model.password"
                background-color="#f8f8f8"
                color="#181C24"
                type="password"
                :rules="[rules.required, rules.validPwdLen, rules.validPwd]"
                solo
                flat
              ></v-text-field>
              <label>{{ $t("profile.repeatPassword") }}</label>
              <v-text-field
                v-model="model.repeatPassword"
                background-color="#f8f8f8"
                color="#181C24"
                type="password"
                :rules="[rules.required, rules.repeatPwd]"
                solo
                flat
              ></v-text-field>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header/Header";
import { mapMutations, mapActions } from "vuex";
export default {
  components: { Header },
  data() {
    return {
      valid: false,
      invalidPwd: false,
      model: {
        password: "",
        repeatPassword: "",
        token: ""
      },
      baseURL: process.env.VUE_APP_API_URL || "/api",
      rules: {
        required: value => !!value || this.$t("errorMessage.required"),
        repeatPwd: value =>
          value === this.model.password ||
          this.$t("errorMessage.repeatPassword"),
        validPwdLen: value =>
          /\S{6,30}$/.test(value) || this.$t("errorMessage.passwordLength"),
        validPwd: value =>
          /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)/.test(value) ||
          this.$t("errorMessage.passwordFormat")
      }
    };
  },
  methods: {
    ...mapActions("snackbar", ["openSnackbar"]),
    ...mapMutations("header", ["setHeaderAttr"]),
    async updatePassword() {
      this.model.token = this.$route.query.token;
      let resStatus = 0;
      fetch(`${this.baseURL}/password`, {
        method: "PUT",
        body: JSON.stringify(this.model),
        headers: new Headers({
          "Content-Type": "application/json"
        })
      })
        .then(res => {
          resStatus = res.status;
          if (resStatus >= 400) return res.json();
        })
        .then(res => {
          if (resStatus >= 400) {
            this.openSnackbar({
              msg: this.mergeErrorMessages(res),
              color: "error"
            });
            return;
          }
          this.openSnackbar({
            msg: this.$t("profile.passwordUpdated"),
            color: "success"
          });
        });
    }
  },
  created() {
    this.setHeaderAttr({
      background: "default",
      fixedTop: false,
      hideAll: true
    });
    this.$vuetify.theme.dark = false;
  }
};
</script>

<style lang="sass" scoped>
.min-height
  min-height: 32rem
.profile-main
  position: absolute
  width: 54rem
  min-height: 30rem
  height: 85%
  border-radius: 1rem
  background: white
  overflow: hidden
  .subheader
    margin: 2.25rem
    margin-bottom: 2rem
    font-size: 1.25rem
    font-weight: bold
  .content
    position: relative
    font-size: 0.85rem
    overflow-y: overlay
  .menu
    background: #181C24
    width: 11rem
    padding-top: 5rem
    a
      user-select: none
      color: white
      &:hover
        color: #ffffffcc
      &.active
        color: #ffa20a
</style>
